/**
 * Helpers shared across the M2 per-domain reducers. Kept thin —
 * cross-reducer utilities only.
 */

import type { DocumentLifecycleState, DocumentRecord } from "@/lib/sse/useSSE";
import { monotonicState } from "@/lib/sse/state-primitives";

const DOC_STATE_ORDER = ["Created", "Hashed", "Attested", "Transmitted", "Validated"] as const satisfies readonly DocumentLifecycleState[];
export const monoDocState = monotonicState(DOC_STATE_ORDER);

/** Legacy alias matching the original useSSE.ts `max(a, b)` shape. */
export function maxDocState(a: DocumentLifecycleState, b: DocumentLifecycleState): DocumentLifecycleState {
  return monoDocState(a, b);
}

export function mapDocs(
  docs: Record<string, DocumentRecord>,
  fn: (d: DocumentRecord, i: number) => DocumentRecord,
): Record<string, DocumentRecord> {
  const out: Record<string, DocumentRecord> = {};
  Object.values(docs).forEach((d, i) => { out[d.type] = fn(d, i); });
  return out;
}
